{
  "info": "Informații",
  "negative": "Eroare",
  "notice": "Avertisment",
  "positive": "Succes"
}
